import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { IdentificationListResponse } from '@frontend/identification/types';

export class IdentificationTagClient extends APIClient {
    public static readonly endpoint = '/identification-api/v1';

    public static async fetchAvailableTags(queryParams?: ApiQueryParams<DefaultQueryParams>): Promise<IdentificationListResponse> {
        return await this.apiPaginated<IdentificationListResponse, DefaultQueryParams>(`${this.endpoint}/available-tags`, queryParams);
    }
}
